import { createFileRoute, redirect } from "@tanstack/react-router";

// Old URL kept alive: permanent redirect to the new question-style URL.
export const Route = createFileRoute("/nica-ayer")({
  beforeLoad: () => {
    throw redirect({ to: "/que-salio-ayer-en-la-nica", statusCode: 301 });
  },
});
